<template>
  <tbody>
    <tr v-for="(data, index) in dataConsolidated" :key="index">
      <td style="text-align: center">
        {{ data.farm.name }}
      </td>
      <td style="text-align: center">
        {{ data.edge }}
      </td>
      <td style="text-align: center">
        {{ data.net_weight_avg }}
      </td>
      <td style="text-align: center">
        {{ data.net_weight_max }}
      </td>
      <td style="text-align: center">
        {{ data.net_weight_min }}
      </td>
      <td style="text-align: center">
        {{ data.stem_weight_avg }}
      </td>
      <td style="text-align: center">
        {{ getFormatNumber(data.hands_number_avg, index) }}
      </td>
      <td style="text-align: center">
        {{ data.hands_number_max }}
      </td>
      <td style="text-align: center">
        {{ data.hands_number_min }}
      </td>
      <td style="text-align: center">
        {{ data.gauge_second_hand_avg }}
      </td>
      <td style="text-align: center">
        {{ data.gauge_last_hand_avg }}
      </td>
      <td style="text-align: center">
        {{ data.length_second_hand_avg }}
      </td>
      <td style="text-align: center">
        {{ data.length_last_hand_avg }}
      </td>
      <td style="text-align: center">
        {{ data.length_last_hand_max }}
      </td>
      <td style="text-align: center">
        {{ data.length_last_hand_min }}
      </td>
      <td style="text-align: center">
        {{ data.fingers_number }}
      </td>
      <td style="text-align: center">
        {{ data.merma }}
      </td>
      <td style="text-align: center">
        {{ data.ratio }}
      </td>
    </tr>
  </tbody>
</template>
<script>
import Formatter from 'src/class/Formatter';

export default {
  name: 'tbody-consolidated',
  props: {
    dataConsolidated: {
      type: Array | Object,
    },
  },
  methods: {
    getFormatNumber(value, index) {
      if (Number(value) === 0) return '';

      switch (index) {
        case 'fingers_number':
          return Formatter.formatNumber(value, 0);
        case 'hands_number_avg':
          return Math.floor(value);

        default:
          return Formatter.formatNumber(value, 2);
      }
    },
  },
};
</script>
